<template>
  <div class="special-gifts-solution d-flex" :class="'--' + item.id" :id="item.anchor">
    <div class="special-gifts-solution__title size6 text-right d-flex align-center justify-end d-md-block" :class="isMD ? 'color-black-50' : 'color-gray'" v-html="item.name"></div>

    <div class="special-gifts-solution__images d-none d-md-flex">
      <div v-for="image in item.images" class="special-gifts-solution__image">
        <!--  Без eager ломается скролл из меню, потому что изображения не успевают загружаться при скролле и не устанавливается их ширина  -->
        <v-img :src="image" :eager="true" />
      </div>
    </div>

    <div class="special-gifts-solution__slider d-md-none">
      <div class="special-gifts-solution__swiper swiper">
        <div class="swiper-wrapper">
          <div v-for="image in item.images" class="swiper-slide">
            <v-img :src="image" />
          </div>
        </div>
      </div>

      <div class="special-gifts-solution__slider-buttons">
        <button class="special-gifts-solution__slider-buttons-prev" :class="{disabled: activeIndex === 0}">
          <svgicon name="arrow-right2"/>
        </button>

        <button class="special-gifts-solution__slider-buttons-next" :class="{disabled: activeIndex === item.images.length - 1}">
          <svgicon name="arrow-right2"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import vp from "@/mixins/vp";
import Swiper, {Navigation, EffectFade} from 'swiper';
import 'swiper/swiper.min.css';

export default {
  name: 'special-gifts-solution',
  mixins: [vp],
  props: {
    item: {
      type: Object,
      required: true,
    },
    currentSolution: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
  methods: {
    startAnimation() {
      const container = document.querySelector('#solutions-container');
      const containerStyle = window.getComputedStyle(container);
      const containerMarginLeft = parseInt(containerStyle.marginLeft, 10);
      const containerPaddingLeft = parseInt(containerStyle.paddingLeft, 10);
      const imagesBlock = document.querySelector(".special-gifts-solution.--" + this.item.id + " .special-gifts-solution__images");
      const imagesBlockWidth = imagesBlock.offsetWidth;
      const titleBlock = document.querySelector(".special-gifts-solution.--" + this.item.id + " .special-gifts-solution__title");
      const titleBlockWidth = titleBlock.offsetWidth;
      const windowWidth = window.innerWidth;
      const leftSideWidth = containerMarginLeft + containerPaddingLeft + titleBlockWidth;
      const containerOffset = containerMarginLeft + containerPaddingLeft;
      const translateValue = (imagesBlockWidth - (windowWidth - leftSideWidth)) + containerOffset;

      gsap.timeline({
        scrollTrigger: {
          trigger: ".special-gifts-solution.--" + this.item.id,
          start: 'top 30%',
          end: '+400%',
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          scrub: true,
          toggleActions: "play reverse play reverse",
          ease: "power0",
          onToggle: (self) => this.currentSolution.trigger = self.trigger.id,
        }
      }).fromTo(".special-gifts-solution.--" + this.item.id + " .special-gifts-solution__title", {
        opacity: 1,
        transform: 'scale(1) translateX(0)',
      }, {
        opacity: 0,
        transform: 'scale(2) translateX(0)',
        duration: 0.4,
      }, 0).fromTo(".special-gifts-solution.--" + this.item.id + " .special-gifts-solution__images", {
        transform: 'translateX(0)',
      }, {
        transform: 'translateX(-' + translateValue + 'px)',
        delay: 0.1,
      }, 0);
    },
    initSwiper() {
      const swiper = new Swiper('.special-gifts-solution.--' + this.item.id + ' .special-gifts-solution__swiper', {
        slidesPerView: 1,
        effect: "fade",
        modules: [Navigation, EffectFade],
        navigation: {
          prevEl: '.special-gifts-solution.--' + this.item.id + ' .special-gifts-solution__slider-buttons-prev',
          nextEl: '.special-gifts-solution.--' + this.item.id + ' .special-gifts-solution__slider-buttons-next',
        },
        on: {
          slideChange: (event) => {
            this.activeIndex = event.activeIndex;
          }
        }
      })
    }
  },
  mounted() {
    if (this.isMD) {
      setTimeout(() => {
        this.startAnimation();
      }, 150);
    }
    else this.initSwiper();
  }
}
</script>

<style lang="scss">
.special-gifts-solution {
  &__title {
    position: relative;
    min-width: 50%;
    width: 50%;
    padding-right: 15px;
    z-index: 1;

    @include up($md) {
      min-width: 470px;
      width: auto;
      padding-right: 57px;
      padding-top: 32px;
      transform-origin: top center;
    }
  }

  &__images {
    gap: 20px;
    position: relative;
    z-index: 2;
  }

  &__image {
    width: auto;
    height: 422px;

    .v-image {
      height: 100%;
    }
  }

  &__slider {
    width: 50%;
    padding-left: 15px;
    position: relative;

    .swiper-wrapper {
      align-items: stretch;
    }

    .swiper-slide {
      height: auto;
      aspect-ratio: 1/1;
    }

    .v-image {
      width: 100%;
      height: 100%;
    }
  }

  &__slider-buttons {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    padding-left: 15px;
    width: 100%;
    z-index: 2;

    button {
      display: block;
      width: 15px;

      svg {
        fill: $golden;
      }

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }

    &-prev {
      margin-left: 5px;

      svg {
        transform: rotate(180deg);
      }
    }

    &-next {
      margin-right: 5px;
    }
  }
}
</style>

